// extracted by mini-css-extract-plugin
module.exports = {"name":"WorkSharingInfoItem_name__3WpXk","value":"WorkSharingInfoItem_value__1S9ij"};